import React, { Component } from "react";
import { Link } from "react-router-dom";
import { yrs } from "./helpers";
import Msg from "./Msg";
import Player from "./Player";

class Players extends Component {
	state = {
		sorted: [],
		results: [],
		msg: {},
	};

	componentDidMount() {
		let yr = yrs()[0]; /* most recent yr */
		let rnd = "0";
		if (this.props.match.params && this.props.match.params.yr) {
			yr = this.props.match.params.yr;
		}
		if (this.props.match.params && this.props.match.params.rnd) {
			rnd = this.props.match.params.rnd;
		}
		this.getMsg("players", yr);
		this.getPlayers(yr, rnd);
	}

	componentWillReceiveProps(nextProps) {
		this.getMsg("players", nextProps.match.params.yr);
		this.getPlayers(nextProps.match.params.yr, nextProps.match.params.rnd);
	}

	async getMsg(page, yr) {
		this.setState({
			msg: {},
		});
		try {
			const response = await fetch(
				`https://valerotexasopen.com/api/public/msg?page=${page}&yr=${yr}`,
				{
					method: "GET",
				}
			);
			const json = await response.json();
			if (json && json.yr) {
				this.setState({
					msg: json,
				});
			}
		} catch (error) {
			console.warn("Error", error);
		}
	}

	async getPlayers(yr, rnd) {
		this.setState({
			sorted: [],
			results: [],
		});
		const f = `/api/public/players`;

		try {
			const response = await fetch(
				`https://valerotexasopen.com/api/public/cdnNEW?f=${encodeURIComponent(
					f
				)}&yr=${yr}&rnd=${rnd}&ma=3600`,
				{
					method: "GET",
				}
			);
			const json = await response.json();
			if (json && json.results) {
				this.setState({
					sorted: json.results,
					results: json.results,
				});
			} else {
				alert("Error loading data.");
			}
		} catch (error) {
			console.warn("Error", error);
		}
	}

	handleKeyUp() {
		const str = this.str.value.replace("'", "’").toLowerCase();
		if (str.length > 0) {
			let array = this.state.results.filter((item, index) => {
				let atLeastOne = false;
				if (item.lname.toLowerCase().substring(0, str.length) == str) {
					atLeastOne = true;
				}
				return atLeastOne;
			});
			this.setState({
				sorted: array,
			});
		} else {
			this.setState({
				sorted: this.state.results,
			});
		}
	}

	render() {
		const players = this.state.sorted.map((item, index) => {
			return <Player key={item.id} data={item} />;
		});

		const years = yrs().map((item, index) => {
			let yr = item;
			let rnd = "4";
			if (item === yrs()[0]) {
				rnd = "0"; /* let init determine what round to start on */
			}

			let liClass = "subpage-tab";
			let liStyle = {};
			if (this.props.match.params && this.props.match.params.yr === item) {
				liClass += " selected";
				liStyle.color = "#fff";
			} else if (!this.props.match.params.yr && item === yrs()[0]) {
				liClass += " selected";
				liStyle.color = "#fff";
			}

			return (
				<li key={index} className={liClass}>
					<Link to={`/${yr}/${rnd}`} style={liStyle}>
						{item}
					</Link>
				</li>
			);
		});

		return (
			<div>
				<ul>{years}</ul>
				<div className="page-break" />
				<Msg msg={this.state.msg} />
				<div className="legend-flex-container">
					<div className="legend-child-flex-container">
						<div className="majorChamp">
							<i className="fa fa-trophy" aria-hidden="true" />
						</div>
						<div>= Major Champion</div>
					</div>
					<div className="legend-child-flex-container">
						<div className="vtoChamp">
							<img
								src="https://vto.qnmcdn.com/assets/img/vto-champion-flag.png"
								alt="VTO Champion"
								style={{ maxWidth: "100%", display: "block" }}
							/>
						</div>
						<div>= Valero Texas Open Champion</div>
					</div>
					<div className="legend-child-flex-container">
						<div className="flagTexas">
							<img
								className="image-shadow"
								src="https://vto.qnmcdn.com/assets/img/flag-icons/Texas.png"
								alt="Texas Flag"
								style={{ maxWidth: "100%", display: "block" }}
							/>
						</div>
						<div>= Born, Resides, or went to School in Texas</div>
					</div>
				</div>
				<div className="spacer" />
				<form className="form-inline players">
					<div className="form-group">
						<div className="input-group">
							<div
								className="input-group-addon"
								style={{ backgroundColor: "#ebf5fa" }}
							>
								<i className="fa fa-search" /> &nbsp; Search:
							</div>
							<input
								type="text"
								className="form-control"
								ref={(ref) => (this.str = ref)}
								onKeyUp={this.handleKeyUp.bind(this)}
								placeholder="Player’s last name"
							/>
						</div>
					</div>
				</form>
				<div className="spacer" />
				<ul id="players">{players}</ul>
			</div>
		);
	}
}

export default Players;



// WEBPACK FOOTER //
// ./src/Players.js